import _ from "lodash"
import { DEFAULT_FEATURE_QUICK_SEARCH_ORDER_CONFIG } from "../constant"
import { IFeatureCategoryObj } from "../interfaces"

const sortCategoryObjByOrder = (categoryObj: IFeatureCategoryObj) => {
  const { type, category } = categoryObj
  const indexOrder = DEFAULT_FEATURE_QUICK_SEARCH_ORDER_CONFIG.findIndex(
    (categoryOrder) => categoryOrder === `${type}.${category}`
  )
  // If category not found it will be sent to last item
  return indexOrder !== -1 ? indexOrder : 9999
}

export const getCategoriesFromFeatures = (features = []) => {
  return _(features)
    .uniqBy((feature) => feature.properties.category)
    .filter(
      (feature) =>
        feature.properties.category &&
        DEFAULT_FEATURE_QUICK_SEARCH_ORDER_CONFIG.includes(
          `${feature.feature_type}.${feature.properties.category}`
        )
    )
    .map(
      (feature): IFeatureCategoryObj => ({
        type: feature.feature_type,
        category: feature.properties.category,
      })
    )
    .orderBy([
      // First Sort by prioritize order from config
      sortCategoryObjByOrder,
      // When order is the same sort by alphabet
      (categoryObj: IFeatureCategoryObj) => {
        const { category } = categoryObj
        return category.toLowerCase()
      },
    ])
    .value()
}
